<section>
    <div class="top_icon">
        <div class="top_icon_back" matTooltip="Expand All" (click)="expandAllDetails()"><mat-icon
                class="top_icon_mat">arrow_drop_down</mat-icon>
        </div>
        <div class="top_icon_back" matTooltip="Collapse All" (click)="collapseAllDetails()"><mat-icon
                class="top_icon_mat">arrow_drop_up</mat-icon>
        </div>
    </div>
    <div class="step_bottom">
        <ul class="tree">
            <ng-container *ngFor="let step of stepsData">
                <li class="parent loopli">
                    <details [open]="step.status === 'INPROGRESS' || step.order === expandStep">
                        <summary>
                            <div class="step">
                                <div class="step_title">{{ step.suiteName != ''? step.suiteName + " > " : ""}}{{
                                    step.stepName}}</div>
                                <div class="step_details">
                                    <div>
                                        <div *ngIf="step.status === 'FAILED'" class="center">
                                            <mat-icon class="fail">close</mat-icon>
                                        </div>
                                        <div *ngIf="step.status === 'PASSED'" class="center">
                                            <mat-icon class="pass">done</mat-icon>
                                        </div>
                                        <div *ngIf="step.status === 'INPROGRESS'" class="center">
                                            <div *ngIf="reportStatus !== 'Aborted'" class="loader"></div>
                                            <mat-icon *ngIf="reportStatus === 'Aborted'" class="fail" matTooltip="Aborted" matTooltipPosition="above">not_interested</mat-icon>
                                        </div>
                                        <div *ngIf="step.status === ''" class="center">
                                            <div *ngIf="reportStatus !== 'Aborted' && reportStatus !== 'Execution Failed' && reportStatus !== 'Failed' && reportStatus !== 'Completed'" class="loading-spinner">
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ellipsis" matTooltip="{{(step.endTime - step.startTime) | duration}}"
                                        *ngIf="step.status === 'FAILED' || step.status === 'PASSED'">{{(step.endTime -
                                        step.startTime) | duration}}</div>
                                </div>
                            </div>
                        </summary>
                        <ul class="step_back">
                            <ng-container *ngTemplateOutlet="stepDataTemplate; context: { step: step, cmdStepsData: step.commandStepsData, prefix: '' }"></ng-container>
                        </ul>
                    </details>
                </li>
            </ng-container>
        </ul>
    </div>
</section>

<ng-template #stepDataTemplate let-stepsData="cmdStepsData" let-step="step" let-prefix="prefix">
    <ng-container *ngFor="let ctv of stepsData; let i = index">
        <li [attr.name]="'loopList' + prefix">
            <ng-container *ngIf="isObject(ctv)" >
                <div class="step_single" [ngClass]="{'inactive-step': ctv.active === false}">
                    <div>{{i+1}}</div>
                    <ul class="remove">
                        <li class="removeli">
                            <div class=" step_single_details" *ngIf="isObject(ctv)">
            
                                <div class="first_step_col {{ctv.command.type}}" *ngIf="ctv.command.name!='comment'">
                                    {{ctv.command.name}}</div>
                                <div class="comment_col" *ngIf="ctv.command.name=='comment'">
                                    <span>{{ctv.value}}</span></div>
                                <div class="second_step_col"
                                    *ngIf="ctv.command.accepts[0]=='target'&& ctv.command.name!='comment'">
                                    {{ctv.target?.name}}</div>
                                <div class="second_step_col"
                                    *ngIf="ctv.command.accepts[1]=='target' && ctv.command.name!='comment'">
                                    {{ctv.target2?.name}}</div>
                                <div class="third_step_col"
                                    *ngIf="(ctv.command.accepts[0]=='value' && ctv.command.name!='comment')||(ctv.command.accepts[0]=='target'&&ctv.command.accepts[1]=='value')">
                                    <ng-container *ngIf="isValue1Secure(ctv); else normalValueInput">
                                        <div class="secure-display">
                                            <mat-icon class="lock-icon">lock</mat-icon>
                                            <span>Secured by {{brand.brandName}}</span>
                                        </div>
                                    </ng-container>
                                    <ng-template #normalValueInput>
                                        <input matInput
                                            id="value" 
                                            name="value"
                                            [(ngModel)]="ctv.value" 
                                            [disabled]="ctv.command.type !== 'API'"
                                            [readonly]="ctv.command.type === 'API'"
                                            [class.api-clickable]="ctv.command.type === 'API'"
                                            [style.cursor]="ctv.command.type === 'API' ? 'pointer' : 'default'"
                                            (click)="ctv.command.type === 'API' && openApiResponseForValue(ctv)">
                                    </ng-template>
                                </div>
                                <div class="third_step_col"
                                    *ngIf="ctv.command.accepts[1]=='value'&&ctv.command.accepts[0]=='value' && ctv.command.name!='comment'">
                                    <input matInput
                                        [matTooltip]="isTemplateMatchCommand(ctv) && (ctv.failureMessage || ctv.warningMessage) ? 'Click to view pass/fail breakdown' : ctv.value2"
                                        name="value2"
                                        [(ngModel)]="ctv.value2"
                                        [disabled]="!(isTemplateMatchCommand(ctv) && (ctv.failureMessage || ctv.warningMessage))"
                                        [readonly]="isTemplateMatchCommand(ctv) && (ctv.failureMessage || ctv.warningMessage)"
                                        [class.api-clickable]="isTemplateMatchCommand(ctv) && (ctv.failureMessage || ctv.warningMessage)"
                                        [style.cursor]="isTemplateMatchCommand(ctv) && (ctv.failureMessage || ctv.warningMessage) ? 'pointer' : 'default'"
                                        (click)="isTemplateMatchCommand(ctv) && (ctv.failureMessage || ctv.warningMessage) && openTemplateResultDialog(ctv)">
                                </div>
                                 <button *ngIf="hasImageSnippet(ctv)" mat-icon-button matTooltip="View Image Snippet" (click)="openImageSnippet(ctv)" class="snippet-eye-btn">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                        </li>
                    </ul>
                    <div>
                        <div *ngIf="ctv.status === 'FAILED' && ctv.failureMessage" class="center">
                            <mat-icon class="fail">close</mat-icon>
                        </div>
                        <div *ngIf="ctv.status === 'FAILED' && !ctv.failureMessage" class="center">
                            <mat-icon class="fail">close</mat-icon>
                        </div>
                        <div *ngIf="ctv.status === 'PASSED' && isRealWarning(ctv)" class="center">
                            <mat-icon class="warn">close</mat-icon>
                        </div>
                        <div *ngIf="ctv.status === 'PASSED' && !isRealWarning(ctv)" class="center">
                            <mat-icon class="pass">done</mat-icon>
                        </div>
                        <div *ngIf="ctv.status === 'INPROGRESS'" class="center">
                            <div *ngIf="reportStatus !== 'Aborted'" class="loader"></div>
                            <mat-icon *ngIf="reportStatus === 'Aborted'" class="fail" matTooltip="Aborted" matTooltipPosition="above">not_interested</mat-icon>
                        </div>
                        <div *ngIf="step.status === ''" class="center">
                            <mat-icon *ngIf="reportStatus !== 'Aborted' && reportStatus !== 'Execution Failed' && reportStatus !== 'Failed' && reportStatus !== 'Completed'" class="pending">pending</mat-icon>
                        </div>
                    </div>
            
                    <div class="ellipsis" matTooltip="{{(ctv.endTime - ctv.startTime) | duration}}"
                        *ngIf="ctv.status === 'FAILED' || ctv.status === 'PASSED'">{{(ctv.endTime -
                        ctv.startTime) | duration}}</div>
                </div>
            
                <div *ngIf="ctv.status === 'FAILED' && ctv.failureMessage" class="step_single" [ngClass]="{'inactive-step': ctv.active === false}">
                    <div></div>
                    <div class="fail">{{inlineMessage(ctv.failureMessage, ctv)}}</div>
                </div>
                <div *ngIf="ctv.status === 'PASSED' && isRealWarning(ctv)" class="step_single" [ngClass]="{'inactive-step': ctv.active === false}">
                    <div></div>
                    <div class="warn" style="display:flex; align-items:center; gap:12px; flex-wrap:wrap;">
                        <span>{{inlineMessage(ctv.warningMessage, ctv)}}</span>

                        <ng-container *ngIf="isApprovalPending(ctv, 'target')">
    <button class="heal-approve-btn" [disabled]="ctv.targetWebobjectApproval.decisionInProgress" (click)="decideWebobjectApproval(ctv, 'target', 'approve')">
        <span *ngIf="ctv.targetWebobjectApproval.decisionInProgress" class="heal-btn-spinner"></span>
        <span>Approve</span>
    </button>
    <button class="heal-reject-btn" [disabled]="ctv.targetWebobjectApproval.decisionInProgress" (click)="decideWebobjectApproval(ctv, 'target', 'reject')">
        <span *ngIf="ctv.targetWebobjectApproval.decisionInProgress" class="heal-btn-spinner"></span>
        <span>Reject</span>
    </button>
</ng-container>
<ng-container *ngIf="ctv.targetWebobjectApproval && ctv.targetWebobjectApproval.status !== 'pending'">
    <span class="heal-approval-label">{{ctv.targetWebobjectApproval.status}}</span>
</ng-container>

<ng-container *ngIf="isApprovalPending(ctv, 'target2')">
    <button class="heal-approve-btn" [disabled]="ctv.target2WebobjectApproval.decisionInProgress" (click)="decideWebobjectApproval(ctv, 'target2', 'approve')">
        <span *ngIf="ctv.target2WebobjectApproval.decisionInProgress" class="heal-btn-spinner"></span>
        <span>Approve</span>
    </button>
    <button class="heal-reject-btn" [disabled]="ctv.target2WebobjectApproval.decisionInProgress" (click)="decideWebobjectApproval(ctv, 'target2', 'reject')">
        <span *ngIf="ctv.target2WebobjectApproval.decisionInProgress" class="heal-btn-spinner"></span>
        <span>Reject</span>
    </button>
</ng-container>
<ng-container *ngIf="ctv.target2WebobjectApproval && ctv.target2WebobjectApproval.status !== 'pending'">
    <span class="heal-approval-label">{{ctv.target2WebobjectApproval.status}}</span>
</ng-container>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="isArray(ctv)">
            <!-- <ng-container *ngIf="isArray(ctv) && ctv[0][0]['status'] != ''"> -->
                <div class="loop_btn">
                    <div>{{i+1}}</div>
                    <div class="top_icon_back" matTooltip="Expand All"
                        (click)="expandDetails(prefix + '.' + (i+1))"><mat-icon
                            class="top_icon_mat">arrow_drop_down</mat-icon>
                    </div>
                    <div class="top_icon_back" matTooltip="Collapse All"
                        (click)="collapseDetails(prefix + '.' + (i+1))"><mat-icon
                            class="top_icon_mat">arrow_drop_up</mat-icon>
                    </div>
                </div>
                <ng-container *ngFor="let loopArray of ctv; let j = index">
                    <li [attr.name]="'loopList' + prefix + '.' + (i+1) " *ngIf="isLoopRequired(ctv, j)">
                        <div class="loop_div">
                            <div class="loop_btn">
                                <div>{{j+1}}</div>
                                <div class="top_icon_back" matTooltip="Expand All"
                                    (click)="expandDetails(prefix + '.' + (i+1) + '.' + (j+1))"><mat-icon
                                        class="top_icon_mat">arrow_drop_down</mat-icon>
                                </div>
                                <div class="top_icon_back" matTooltip="Collapse All"
                                    (click)="collapseDetails(prefix + '.' + (i+1) + '.' + (j+1))"><mat-icon
                                        class="top_icon_mat">arrow_drop_up</mat-icon>
                                </div>
                            </div>
                            <div class="loop_div">
                                <ng-container *ngTemplateOutlet="stepDataTemplate; context: { step: step, cmdStepsData: loopArray, prefix: prefix + '.' + (i+1) + '.' + (j+1)}"></ng-container>
                            </div>
                        </div>
                    </li>
                </ng-container>
            </ng-container>
        </li>        
    </ng-container>
 </ng-template>